export default __webpack_public_path__ + "static/cloudMigration-62c45ce3a24507c80da49b59f2a6e03d.svg";